import { Helmet } from 'react-helmet-async';
import OneDriveEmbed from '../components/OneDriveEmbed';

export default function TermsPage() {
  const embedUrl = 'REPLACE_WITH_ONEDRIVE_TERMS_EMBED_URL';

  return (
    <>
      <Helmet><title>Drs.Farm | 規約</title></Helmet>
      <h1>利用規約</h1>
      <p className="page-lead">公開情報の取り扱い、著作権、利用条件を定めています。</p>
      <section className="panel">
        <h2>要点サマリー</h2>
        <ul>
          <li>本サイトのデータは農業情報の透明性向上のために公開されています。</li>
          <li>無断転載・商用転用は運営許可が必要です。</li>
          <li>投稿・画像の著作権は各権利者に帰属します。</li>
        </ul>
      </section>
      <section className="panel">
        <h2>規約原本（OneDrive）</h2>
        <OneDriveEmbed embedUrl={embedUrl} title="Drs.Farm 利用規約" />
      </section>
    </>
  );
}
